export const SIDEBAR_ITEMS = [
  {
    id: "transportation",
    name: "transportation",
    icon: "sidebar/transportation",
    url: "/transportation",
    apiKey: "api::transportation",
    controllerKey: "transportation",
  },
  {
    id: "event",
    name: "event",
    icon: "sidebar/event",
    url: "/events",
    apiKey: "api::event",
    controllerKey: "event",
    subItems: [
      {
        name: "event_category",
        url: "/events/categories",
      },
    ],
  },
  {
    id: "mall",
    name: "mall",
    icon: "sidebar/mall",
    url: "/malls",
    apiKey: "api::mall",
    controllerKey: "mall",
    subItems: [
      {
        name: "mall_category",
        url: "/malls/categories",
      },
    ],
  },
  {
    id: "travel-destination",
    name: "travel-destination",
    icon: "sidebar/travel-destination",
    url: "/travel-destinations",
    apiKey: "api::travel-destination",
    controllerKey: "travel-destination",
    subItems: [
      {
        name: "travel-destination_category",
        url: "/travel-destinations/categories",
      },
    ],
  },
  {
    id: "cultural-historical",
    name: "cultural_historical",
    icon: "sidebar/cultural-historical",
    url: "/cultural-historical",
    apiKey: "api::cultural-historical",
    controllerKey: "cultural-historical",
    subItems: [
      {
        name: "cultural_historical_category",
        url: "/cultural-historical/categories",
      },
    ],
  },
  {
    id: "hotel",
    name: "hotel",
    icon: "sidebar/hotel",
    url: "/hotels",
    apiKey: "api::hotel",
    controllerKey: "hotel",
  },
  {
    id: "tour",
    name: "tour",
    icon: "sidebar/tour",
    url: "/tours",
    apiKey: "api::tour",
    controllerKey: "tour",
    subItems: [
      {
        name: "tour_category",
        url: "/tours/categories",
      },
      {
        name: "tour_duration",
        url: "/tours/durations",
      },
      {
        name: "tour_type",
        url: "/tours/types",
      },
    ],
  },
  {
    id: "travel-company",
    name: "travel_company",
    icon: "sidebar/travel-company",
    url: "/travel-companies",
    apiKey: "api::travel-company",
    controllerKey: "travel-company",
    subItems: [
      {
        name: "travel_company_tag",
        url: "/travel-companies/tags",
      },
    ],
  },
  {
    id: "state-agency",
    name: "state_agency",
    icon: "sidebar/state-agency",
    url: "/state-agencies",
    apiKey: "api::state-agency",
    controllerKey: "state-agency",
    subItems: [
      {
        name: "state_agency_category",
        url: "/state-agencies/categories",
      },
    ],
  },
  {
    id: "restaurant",
    name: "restaurant",
    icon: "sidebar/restaurant",
    url: "/restaurants",
    apiKey: "api::restaurant",
    controllerKey: "restaurant",
    subItems: [
      {
        name: "restaurant_tag",
        url: "/restaurants/tags",
      },
    ],
  },
  {
    id: "food",
    name: "food",
    icon: "sidebar/food",
    url: "/foods",
    apiKey: "api::food",
    controllerKey: "food",
    subItems: [
      {
        name: "food_category",
        url: "/foods/categories",
      },
      {
        name: "food_type",
        url: "/foods/types",
      },
    ],
  },
  {
    id: "entertainment-venue",
    name: "entertainment_venue",
    icon: "sidebar/entertainment-venue",
    url: "/entertainment-venue",
    apiKey: "api::entertainment-venue",
    controllerKey: "entertainment-venue",
    subItems: [
      {
        name: "entertainment_venue_category",
        url: "/entertainment-venue/categories",
      },
    ],
  },
  {
    id: "medical-center",
    name: "medical_center",
    icon: "sidebar/medical-center",
    url: "/medical-centers",
    apiKey: "api::medical-center",
    controllerKey: "medical-center",
    subItems: [
      {
        name: "medical_center_category",
        url: "/medical-centers/categories",
      },
      {
        name: "medical_center_department",
        url: "/medical-centers/departments",
      },
    ],
  },
  {
    id: "police-headquarter",
    name: "police_headquarter",
    icon: "sidebar/police-headquarter",
    url: "/police-headquarters",
    apiKey: "api::police-headquarter",
    controllerKey: "police-headquarter",
    subItems: [
      {
        name: "police_headquarter_category",
        url: "/police-headquarters/categories",
      },
    ],
  },
  {
    id: "settings",
    name: "settings",
    icon: "sidebar/settings",
    url: "/settings",
    apiKey: "plugin::users-permissions",
    controllerKey: "role",
  },
]
